console.log('__akfunctions.js v2.7.2 ->');

/*eslint-disable */
function getbh(){
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};

function getbb(){
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

function getspt(){
  return (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
}

function getspb(){
  return ( (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0) ) + getbh();
}
/*eslint-enable */


var spt = getspt();
$(window).scroll(function(event) {
   spt = getspt() > 0 ? getspt() : 0;
});


// //SCROLL IN VIEW <- make it a function
// function scrollinview($el, treshold, distance){

//   var treshold = typeof treshold !== 'undefined' ? treshold : 150;
//   var distance = typeof distance !== 'undefined' ? distance : treshold;
//   var position = $el.offset().top

//   console.log('scrollinview() -> $el.position: '+ position +' spb: '+ getspb() +' [-'+treshold+']' );

//   if (getspb() < position + treshold){ console.log('scrollinview() -> scrolling '+distance)
//     $('html, body').animate({scrollTop: (position + distance - getbh()) + 'px'}, 250)
//   }
// }



//AKBILDSCHIRM

var bb, bh;
var refreshcount = 0;

$.fn.akbildschirm = function(init){ console.log( 'fn.akbildschirm() ->');

  bb = getbb();
  bh = getbh();

  console.log('bb: '+bb+' bh: '+bh);

  this.each(function(index) {

    $this = $(this);

    var ratio = (bb/bh > 1) ? 'landscape' : 'portrait';
    var shape = (bb/bh >= 0.75 && bb/bh <= 1.5) ? 'square' : 'panorama';

    /*eslint-disable */
    var is_mobile = (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4)));
    var is_HD = ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
    var is_Retina = ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    /*eslint-enable */

    var is_iPhone = (navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i));
    var is_iPad = (navigator.userAgent.match(/iPad/i));

    var is_iPhone6p = ( ( bb == 414 && bh >= 628 && ratio=='portrait' ) || ( bb == 736 && bh >= 306 && ratio=='landscape' ) ) && is_iPhone;
    var is_iPhone6 = ( ( bb == 375 && bh >= 559 && ratio=='portrait' ) || ( bb == 667 && bh >= 267 && ratio=='landscape' ) ) && is_iPhone;
    var is_iPhone5 = ( ( bb == 320 && bh >= 460 && ratio=='portrait' ) || ( bb == 568 && bh >= 212 && ratio=='landscape' ) ) && is_iPhone;
    var is_iPhone4 = ( ( bb == 320 && bh >= 372 && ratio=='portrait' ) || ( bb == 480 && bh >= 212 && ratio=='landscape' ) ) && is_iPhone;

    if ( ( bb >= 1350 && bh >= 900 && ratio=='landscape' ) || ( bb >= 675 && bh >= 900 && ratio=='portrait' ) ) size = 'XL';
    else if ( ( bb >= 960 && bh >= 640 && ratio=='landscape' ) || ( bb >= 480 && bh >= 640 && ratio=='portrait' ) ) size = 'L';
    else if ( ( bb >= 720 && bh >= 480 && ratio=='landscape' ) || ( bb >= 360 && bh >= 480 && ratio=='portrait' ) ) size = 'M';
    else size = 'S';

    //OUTPUT:

    $this.removeClass('retina HD mobile desktop S M L XL landscape portrait square panorama iPad iPhone iPhone6p iPhone6 iPhone5 iPhone4');

    if (is_Retina) $this.addClass('retina');
    if (is_HD && !is_Retina) $this.addClass('HD');
    if (is_iPhone) $this.addClass('iPhone');
    if (is_iPad) $this.addClass('iPad');

    if (is_iPhone6p) $this.addClass('iPhone6p');
    if (is_iPhone6) $this.addClass('iPhone6');
    if (is_iPhone5) $this.addClass('iPhone5');
    if (is_iPhone4) $this.addClass('iPhone4');

    if (is_mobile) $this.addClass('mobile');
    else $this.addClass('desktop');

    $this.addClass(shape);
    $this.addClass(ratio);
    $this.addClass(size);

    if (init){
      $(window).resize(function(event) {
        $this.akbildschirm();
        refreshcount++;
      });
    }
  });
};

//END AKBILDSCHIRM


//FORMFUNCTIONS
$.fn.akaddplaceholder = function(removelable, removerequired){ console.log('fn.akaddplaceholder() ->');

  this.find('input[type=text], input[type=password], textarea').each(function(index, el) {
    if (removerequired) $(this).prev('label').find('span.form-required').remove();
    $(this).attr('placeholder', $(this).prev('label').text() );
    if (removelable) $(this).prev('label').hide();
  });
};

// $.fn.akwrapformitemsold = function(){ console.log('akwrapformitems() ->');
//   //Item: inline inline gets wrapped; newline breaks
//   this.find('.inline').each(function(){
//     if ( $(this).parent().hasClass('inlinewrap') ) return;
//     $(this).nextUntil("div:not(.inline), .newline").andSelf().wrapAll('<div class="inlinewrap" />');
//   });
// };

$.fn.akwrapformitems = function(addclasses){ console.log('akwrapformitems() -> addclasses: '+addclasses);

  addclasses = typeof addclasses !== 'undefined' ? addclasses+' ' : '';

  this.each(function(){
    if ( $(this).hasClass('akwrapformitems-wrapitem') ) return;
    $(this).addClass('tmp-akwrapme akwrapformitems-wrapitem wrapitem ');
  });

  $('.tmp-akwrapme').each(function(){
    if ( $(this).parent().hasClass('akwrapformitems-wrapped') ) return;
    $(this).nextUntil("div:not(.tmp-akwrapme)").andSelf().wrapAll('<div class="'+addclasses+'tmp-akwrapped akwrapformitems-wrapped wrapped" />');
  });

  $('.tmp-akwrapme').removeClass('tmp-akwrapme');
  $('.tmp-akwrapped').removeClass('tmp-akwrapped');

};
//END FORMFUNCTIONS

//AKARM
$.fn.akarm = function(closestSelector, excludeSel, excludeLinks){ console.log('akarm() ->');

  excludeLinks = typeof excludeLinks !== 'undefined' ? excludeLinks : true;

  this.each(function(index, el) {
    $that = $(this);
    $that.addClass('akarmed-master');
    $that.closest(closestSelector).addClass('akarmed-slave')

    $that.closest(closestSelector).css('cursor','pointer');
    if (typeof excludeSel !== 'undefined') $that.find(excludeSel).css('cursor','default');

    $that.closest(closestSelector).on('click', function(event) { console.log('akarm() -> .akarmed-master clicked');
      if ( $(event.target).hasClass('akarmed-master') ) return true;
      if (excludeLinks) if ( $(event.target).is('a') ) return true;
      if (typeof excludeSel !== 'undefined') if ( ($(event.target).is(excludeSel)) || $(this).find(excludeSel).find(event.target).length ) { console.log('akarm() -> excludeSel clicked'); return true };
      event.preventDefault();
      //$that.trigger('click');
      $(this).find('.akarmed-master').trigger('click');
    });
  });
};
//Example: $('.example .usage a').akarm('.example', '.example .usage');
//END AKARM


//AKONEPAGENAV
$.fn.akonepagenav = function(container_selector, page_selector, title_selector){ console.log('fn.akonepagenav() ->');
  //Usage: CONTAINER, PAGES, TITLE

  var $akopn_nav_parent = this;
  var $akopn_page_parent = $(container_selector);

  $akopn_page_parent.find(page_selector).each(function(index, el) {
    $akopn_nav_parent.append('<div class="AKonepagenav-bullet">'+$(this).find(title_selector).text()+'</div>');
  });

  $(window).scroll(function(event) {
    console.log( getspt() );
    set_akopn_classes();
  }); set_akopn_classes();

  function set_akopn_classes(){

    //TODO: USE global var spt!!!

    $akopn_page_parent.find(page_selector).each(function(index, el) {

      if ( $(this).offset().top + $(this).height() < getspt() ){
        $(this).addClass('scrolled-past');
        $akopn_nav_parent.find('.AKonepagenav-bullet').eq($(this).index(page_selector)).addClass('scrolled-past');
      } else{
        $(this).removeClass('scrolled-past');
        $akopn_nav_parent.find('.AKonepagenav-bullet').eq($(this).index(page_selector)).removeClass('scrolled-past');
      }

      if ( $(this).offset().top < getspt() + getbh()/2 ){
        $(this).addClass('was-viewed');
        $akopn_nav_parent.find('d.AKonepagenav-bullet').eq($(this).index(page_selector)).addClass('was-viewed');
      } else{
        $(this).removeClass('was-viewed');
        $akopn_nav_parent.find('.AKonepagenav-bullet').eq($(this).index(page_selector)).removeClass('was-viewed');
      }

    });

    $akopn_page_parent.find('.in-view').removeClass('in-view');
    $akopn_page_parent.find('.was-viewed:last').addClass('in-view');

    $akopn_nav_parent.find('.in-view').removeClass('in-view');
    $akopn_nav_parent.find('.was-viewed:last').addClass('in-view');
  }
}
//Example: $('#AKonepagenav:first').akonepagenav('.view-pageslide', 'article.node', '.field.title');
//END AKONEPAGENAV




//AKCLACULATEIMAGES
$.fn.akCalculateImage = function(option, ignoreparents){ console.log('fn.akCalculateImage() ->');
  // clostetEL later?
  option = typeof option !== 'undefined' ? option : 'contain';
  ignoreparents = typeof ignoreparents !== 'undefined' ? ignoreparents : 0;

  var fill, stretch;

  if ( option == 'stretch' ){ stretch = true; }
  if ( option == 'fill' ){ stretch = true; fill = true; }

  this.each(function(index, el){ console.log('akCalculateImage() ->')

    $that = $(this);

    $that.addClass('akCalculateImage');

    $that.css('min-width', 'none').css('min-height', 'none').css('max-width', 'none').css('max-height', 'none').css('width', '').css('height', '');

    var $parent = $that.parents().eq(1);

    var parentWidth = $parent.width();
    var parentHeight = $parent.height();

    $parent.attr('data-akCalculateImage-width', parentWidth);
    $parent.attr('data-akCalculateImage-height', parentHeight);

    $that.attr('data-akCalculateImage-option', option).attr('data-akCalculateImage-ignoreparents', ignoreparents);


    var thisOriginalWidth = $that.attr('width');
    var thisOriginalHeight = $that.attr('height');

    if (!fill){
      var factor = Math.min( parentWidth / thisOriginalWidth, parentHeight / thisOriginalHeight );
    }
    else{
      var factor = Math.max( parentWidth / thisOriginalWidth, parentHeight / thisOriginalHeight );
      stretch = true;
    }

    if (!stretch && factor > 1) factor = 1;

    $that.css('width', Math.ceil(factor * thisOriginalWidth) +'px' );
    $that.css('height', Math.ceil(factor * thisOriginalHeight) +'px' );

    //2ndrun
    if (fill) return;

    parentWidth = $parent.width();
    parentHeight = $parent.height();

    $parent.attr('data-akCalculateImage-width', parentWidth);
    $parent.attr('data-akCalculateImage-height', parentHeight);

    if (!fill){
      var factor = Math.min( parentWidth / thisOriginalWidth, parentHeight / thisOriginalHeight );
    }
    else{
      var factor = Math.max( parentWidth / thisOriginalWidth, parentHeight / thisOriginalHeight );
      stretch = true;
    }

    if (!stretch && factor > 1) factor = 1;

    $that.css('width', Math.ceil(factor * thisOriginalWidth) +'px' );
    $that.css('height', Math.ceil(factor * thisOriginalHeight) +'px' );

  });
};
$(window).resize(function(){

  $('.akCalculateImage').each(function(index, el) {

    // if ( $(this).hasClass('akCalculateImage-fill') ) $(this).akCalculateImage('fill');
    // else if ( $(this).hasClass('akCalculateImage-stetch') ) $(this).akCalculateImage('stretch');
    $(this).akCalculateImage( $(this).attr('data-akCalculateImage-option'), $(this).attr('data-akCalculateImage-ignoreparents') );

  });
});
//END AKCLACULATEIMAGES


//AKOUTDATED
function akoutdated(force){ console.log('akoutdated() -> force: '+force);
  if ($('#akoutdated').length < 1) console.error('no #akoutdated');
  if (force) return false;
  $('#akoutdated').hide();
  if (Modernizr.flexbox && Modernizr.csstransforms) $('#akoutdated').remove();
  else $('#akoutdated').show();
};

//Remove Ajax-Container
function removeajaxresult(){ console.log('removeajaxresult()');
  $('#ajaxresult').remove();
}


//AKAUTOMENU
var akautomenu_lastscrollpos = spt;
var akautomenu_position;

$.fn.akautomenu = function(init){ console.log('akautomenu() ->');
  init = typeof init !== 'undefined' ? init : 0;

  if ( $('.akautomenu').length ){ console.error('akautomenu() -> already called once'); return false; }

  var $this = this

  $this.addClass('akautomenu akautomenu-up').css('transform', 'translateY('+spt+'px)').css('-webkit-transform', 'translateY('+spt+'px)').css('-moz-transform', 'translateY('+spt+'px)').css('-ms-transform', 'translateY('+spt+'px)').css('-o-transform', 'translateY('+spt+'px)');
  akautomenu_position = spt

  if ( spt <= init ) $this.addClass('akautomenu-init')
  else $this.removeClass('akautomenu-init')

  //$('.akautomenu').attr('data-akautomenu-lastscrollpos', spt)
  akautomenu_lastscrollpos = spt

  $(window).scroll(function(){ console.log('akautomenu() -> scroll '+spt);

    var $this = $('.akautomenu:first')

    //var lastscrollpos = $this.attr('data-akautomenu-lastscrollpos')           --> akautomenu_lastscrollpos

    if ( spt <= init ) $this.addClass('akautomenu-init')
    else $this.removeClass('akautomenu-init')

    if ( spt > akautomenu_lastscrollpos && !$this.hasClass('aksandwich-opened') ){
      $this.addClass('akautomenu-down').removeClass('akautomenu-up')
      if (spt > akautomenu_position+$this.outerHeight() ) $this.addClass('akautomenu-away')
    }
    else if ( spt <  akautomenu_lastscrollpos || $this.hasClass('aksandwich-opened') ){

      $this.addClass('akautomenu-up').removeClass('akautomenu-down akautomenu-away')
      $this.css('transform', 'translateY('+spt+'px)').css('-webkit-transform', 'translateY('+spt+'px)').css('-moz-transform', 'translateY('+spt+'px)').css('-ms-transform', 'translateY('+spt+'px)').css('-o-transform', 'translateY('+spt+'px)');
      akautomenu_position = spt
    }

    //$this.attr('data-akautomenu-lastscrollpos', spt)
    akautomenu_lastscrollpos = spt


  });
}

//AKAUTOMENU
// $.fn.akautomenu = function(init, threshold){ console.log('akautomenu() ->');
//   init = typeof init !== 'undefined' ? init : 0;
//   threshold = typeof threshold !== 'undefined' ? threshold : 50;
//
//   if ( $('.akautomenu').length ){ console.error('akautomenu() -> already called once'); return false; }
//
//   var $this = this
//
//   $this.addClass('akautomenu akautomenu-up').css('transform', 'translateY('+spt+'px)').css('-webkit-transform', 'translateY('+spt+'px)').css('-moz-transform', 'translateY('+spt+'px)').css('-ms-transform', 'translateY('+spt+'px)').css('-o-transform', 'translateY('+spt+'px)');
//
//   if ( spt <= init ) $this.addClass('akautomenu-init')
//   else $this.removeClass('akautomenu-init')
//
//   $('.akautomenu').attr('data-akautomenu-lastscrollpos', spt)
//
//   $(window).scroll(function(){ console.log('akautomenu() -> scroll '+spt);
//
//     var $this = $('.akautomenu:first')
//
//     var lastscrollpos = $this.attr('data-akautomenu-lastscrollpos')
//     var position = $this.attr('data-akautomenu-position')
//
//     if ( spt <= init ) $this.addClass('akautomenu-init')
//     else $this.removeClass('akautomenu-init')
//
//     if ( spt > lastscrollpos && spt > position && !$this.hasClass('aksandwich-opened') ){
//       $this.addClass('akautomenu-down').removeClass('akautomenu-up')
//       $this.attr('data-akautomenu-lastscrollpos', spt)
//     }
//     else if ( spt <  (lastscrollpos-threshold) || spt <= position || $this.hasClass('aksandwich-opened') ){
//       //var wasdown = $this.hasClass('akautomenu-down') ? true:false;
//
//       $this.addClass('akautomenu-up').removeClass('akautomenu-down')
//       $this.css('transform', 'translateY('+spt+'px)').css('-webkit-transform', 'translateY('+spt+'px)').css('-moz-transform', 'translateY('+spt+'px)').css('-ms-transform', 'translateY('+spt+'px)').css('-o-transform', 'translateY('+spt+'px)');
//       $this.attr('data-akautomenu-lastscrollpos', spt).attr('data-akautomenu-position', spt)
//     }
//
//
//   });
// }
//
